// Brand constants
export const BRAND_COLOR = '#80cca5'
export const COMPANY_NAME = 'controlstack.ai'
export const YOUTUBE_CHANNEL = 'DarrenBuildsAI'
export const YOUTUBE_URL = 'https://youtube.com/@DarrenBuildsAI'
export const TWITTER_HANDLE = '@DarrenBuildsAI'

// Storage keys
export const COOKIE_CONSENT_KEY = 'cookie-consent'
export const THEME_STORAGE_KEY = 'theme'

// Social proof (legacy, kept for old components)
export const TRUSTED_COMPANIES = [
  'Google',
  'Meta',
  'Stripe',
  'Vercel',
  'OpenAI',
] as const

// Community signup form options (updated based on persona research)
export const INTEREST_OPTIONS = [
  {
    value: 'community',
    label: 'Join a community of AI builders',
    description: 'Connect with developers and founders shipping AI products',
  },
  {
    value: 'cohort',
    label: 'Join a structured cohort with deadlines',
    description: 'Build together with accountability and live feedback',
  },
  {
    value: 'tools',
    label: 'Learn specific AI tools through real builds',
    description:
      'Master OpenCode, Claude Code, Cursor through hands-on projects',
  },
  {
    value: 'accountability',
    label: 'Get accountability and feedback',
    description: 'Weekly check-ins and support to actually finish projects',
  },
  {
    value: 'product',
    label: 'Build an AI product with guidance',
    description: 'Ship a real AI product from idea to deployment',
  },
] as const

// Background options (replaces SKILL_LEVEL_OPTIONS)
export const BACKGROUND_OPTIONS = [
  {
    value: 'senior_dev',
    label: 'Senior Developer',
    description: '5+ years of professional development experience',
  },
  {
    value: 'mid_dev',
    label: 'Mid-Level Developer',
    description: '2-5 years of professional development experience',
  },
  {
    value: 'founder',
    label: 'Technical Founder/Entrepreneur',
    description: 'Building or planning to build an AI product',
  },
  {
    value: 'manager',
    label: 'Engineering Manager/Leader',
    description: 'Leading a team or evaluating AI tools for adoption',
  },
  {
    value: 'other',
    label: 'Other',
    description: 'Something else',
  },
] as const

export const REFERRAL_SOURCE_OPTIONS = [
  { value: 'youtube', label: 'YouTube' },
  { value: 'twitter', label: 'Twitter/X' },
  { value: 'google', label: 'Google search' },
  { value: 'friend', label: 'Friend referral' },
  { value: 'other', label: 'Other' },
] as const

// Type exports for form values
export type InterestValue = (typeof INTEREST_OPTIONS)[number]['value']
export type BackgroundValue = (typeof BACKGROUND_OPTIONS)[number]['value']
export type ReferralSourceValue =
  (typeof REFERRAL_SOURCE_OPTIONS)[number]['value']

// Legacy type aliases for backward compatibility
export type SkillLevelValue = BackgroundValue
export type BusinessStageValue = BackgroundValue
